import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { updateBillingInformation } from 'modules/settings/api';

export const useMutationBillingInformation = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { successToast, errorToast } = useCustomToast();

  const { mutateAsync: updateBillingInformationMutation, isLoading: billingInformationLoading } =
    useMutation(updateBillingInformation, {
      onSuccess: () => {
        successToast(t('Company information updated'));
        queryClient.refetchQueries(QUERY_KEYS.SETTINGS_PROFILE_BILLING_INFORMATION);
      },
      onError: () => errorToast(),
    });

  return { updateBillingInformationMutation, billingInformationLoading };
};
